import { ProductEntry } from '../../../store/api';
import { ExtendedManageRenewalCells, ExtendedRenewalTile, ManageRenewalCells } from '../utils/renewalTableTileTypes';
import { mapExtendedRenewalOverview } from './mapExtendedRenewalOverview';
import { mapExtendedIndividual } from './mapExtendedIndividual';
import { mapExtendedShared } from '../../../shared/subscription-management/mappings/mapExtendedShared';
import { UpdateLineItemsParams } from '../../../api/subscription-management/renewals/updateRenewalLine';

export const mapExtendedRenewalBody = (
    renewalEntries: ProductEntry[],
    updateRenewalLine: (params: UpdateLineItemsParams) => void,
    spocCurrency: string
): ExtendedManageRenewalCells => {
    const list: ExtendedRenewalTile[] = renewalEntries.map(entry => {
        return {
            product: entry.product,
            overview: mapExtendedRenewalOverview(entry),
            individual: mapExtendedIndividual(entry, updateRenewalLine, spocCurrency),
            shared: mapExtendedShared(entry)
        };
    });

    return {
        type: ManageRenewalCells.Extended,
        list
    };
};
